import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { BenefitsIconProps } from "../StickyBottomBar.d";

export const BenefitIcon = ({ icon: Icon }: BenefitsIconProps) => {
  const isStoryblokIcon = Array.isArray(Icon);
  const shouldRenderIcon = !isStoryblokIcon || Icon?.length > 0;
  return shouldRenderIcon ? isStoryblokIcon ? renderDynamicComponent(Icon) : <Icon /> : null;
};
